import React from "react";
import {
    DepositPhase,
    DepositState,
    PaymentStateStatus,
    WithdrawPhase,
    WithdrawState
} from "../../payments/PaymentsReducer";
import ChooseAddress from "../withdraw/ChooseAddress";
import ChooseAmount from "../withdraw/ChooseAmount";
import ConfirmWithdraw from "../withdraw/ConfirmWithdraw";
import WithdrawResponseView from "../withdraw/WithdrawResponseView";
import {t} from "../../i18n";
import {GlobalPayload, OnboardingPagePayload} from "../../contenful/types";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {CurrencyDefinition, PaymentMethod, Settings, UserInfo} from "../../http/protocol";
import {initDeposit, showCashier, updateDepositPhase} from "../../payments/DepositActions";
import {AppState} from "../../RootReducer";
import {LoginStatus, Status} from "../../http/Types";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import CryptoDeposit from "./sharedcomponents/CryptoDeposit";
import Loader from "../../layout/Loader";
import {BrandA} from "../buttons/buttons";
import { ReactNode } from "react-markdown";


interface State {
}

type AllProps = PropsFromState & PropsFromDispatch & OtherProps;


export class GBLPaymentComponent extends React.Component<AllProps, State> {
    constructor(props:AllProps) {
        super(props);
        console.log("GBL CODE: ", this.props.code)
    }

    componentDidMount() {
        this.props.updatePhase && this.props.updatePhase(DepositPhase.PROVIDER_CONTENT);
        if(this.props.type == "deposit") {
            this.props.initDeposit && this.props.initDeposit();
        }
    }

    renderWithdraw() {
        let withdraw = this.props.withdraw != undefined ? this.props.withdraw : {};
        let phase = withdraw && withdraw.phase;
        return(
            <div className="withdraw-title">
                {phase == WithdrawPhase.CHOOSE_ADDRESS && withdraw && withdraw.activeMethod && (
                    <ChooseAddress code={this.props.code}/>
                )}
                {phase == WithdrawPhase.CHOOSE_AMOUNT && (
                    <ChooseAmount />
                )}
                {phase == WithdrawPhase.CONFIRM_WITHDRAW && (
                    <ConfirmWithdraw />
                )}
                {phase == WithdrawPhase.WITHDRAW_RESPONSE && withdraw  && this.props.handleClickOk && (
                    <WithdrawResponseView onClick={this.props.handleClickOk}/>
                )}
                {phase === WithdrawPhase.REQUEST_DENIED && (
                    <div className="requestDenied">
                        <span>{t(`withdraw.requestDenied-reason.${withdraw.withdrawResponse?.result ?? 'ERROR'}`)}</span>
                    </div>
                )}
                {phase === WithdrawPhase.ERROR && (
                    <div className="requestDenied">
                        <span>{t("withdraw.withdrawError")}</span>
                    </div>
                )}
            </div>
        )
    }

    renderDeposit() {
        if(this.props.deposit.status == PaymentStateStatus.DEPOSIT_INITIATED) {
            return (
                <div className={"deposit-content"}>
                    <Loader />
                </div>
            )
        }
        let dialog = this.props.deposit.depositDialog;
        let currencyCode = this.props.activeCurrency || "";
        let decimals: number = 0;
        if(this.props.user && this.props.user.currencies) {
            this.props.user.currencies.forEach((cd:CurrencyDefinition) => {
                if(cd.fractionalDigits && dialog && dialog.payment && cd.code == dialog.payment.currency) {
                    decimals = cd.fractionalDigits;
                }
            })
        }
        return(
            <div className="deposit-content">
                {dialog
                && dialog.payment
                && <CryptoDeposit address={dialog.customContext.address}
                                  currencyCode={currencyCode}
                                  decimals={decimals}
                                  generateNew={this.props.activeMethod?.canReuseAddress}
                                  warningText={t("payments.maxDecimalsWarning")}/>
                }
                {this.props.handleClickStartPlaying && <BrandA className={"btn btn-cta full-width large"}  onClick={this.props.handleClickStartPlaying}>{t("global.startPlaying")}</BrandA>}
            </div>
        )
    }

    render(): ReactNode | ReactNode[]  {
        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}

interface OtherProps extends RouteComponentProps {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
    handleClickStartPlaying?: () => void;
    code?:string;
}

interface PropsFromState {
    deposit: DepositState;
    onboardingpage?: OnboardingPagePayload;
    settings?: Settings;
    registrationStatus: boolean;
    user?: UserInfo;
    show?: boolean;
    activeCurrency?: string;
    activeMethod?:PaymentMethod;
}

interface PropsFromDispatch {
    hide: () => void;
    updatePhase: typeof updateDepositPhase;
    initDeposit: typeof initDeposit;
}


const mapStateToProps = ({payments, contentful, settings, user} : AppState) => {
    let status = false;
    if(user.registration && user.registration.status) {
        if(user.registration.status == Status.SUCCESS) {
            status = true;
        }
    }
    return {
        deposit : payments.deposit,
        onboardingpage: contentful.onboardingpage,
        settings: settings.settings,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        registrationStatus : status,
        user: user.user,
        show: payments.cashier.showCashierModal,
        activeCurrency: user.activeCurrency,
        activeMethod: payments.deposit.activeMethod,
    }
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        initDeposit : () => dispatch(initDeposit() as any),
        hide : () => dispatch(showCashier(false)),
        updatePhase : (phase:DepositPhase) => dispatch(updateDepositPhase(phase))
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<AllProps,any>(GBLPaymentComponent));